// Translator notes: The self-check before output (engine/src/self-check.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  selfCheckClearer: {
    args: ['hv'],
    fi: (a: string[]) =>
      `Ensimmäinen käännösvaihtoehto olisi voitu lukea väärin, joten tilalle valittiin selkeämpi sana ${a[0]}. Ensimmäinen vaihtoehto on vaihtoehtojen joukossa.`,
    en: (a: string[]) => `The first choice could have been read wrongly, so the clearer word ${a[0]} was chosen. The first choice is among the alternatives.`,
  },
  selfCheckRoles: {
    args: ['word'],
    fi: (a: string[]) => `Tarkista sanan ${a[0]} rooli: takaisin luettuna sen voi ymmärtää toisessa sijassa tai persoonassa.`,
    en: (a: string[]) => `Check the role of ${a[0]}: read back, it can be taken in another case or person.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
